module.exports = __webpack_public_path__ + "img/calendar-wiki-cover-default.97148a1c.png";